// D32 (docs/ticket-detail-2027/05-front/d32-plano.md + d32.md): a conversa do WhatsApp do detalhe do ticket fica ancorada no fim.
// Quem rola é a .messages-chat-whats (.max-full-h, overflow-y:auto); o #body-chat (.scroll) é overflow:hidden e não rola, por isso
// o $('.scroll').animate do Chats.js não faz nada aqui. Nada neste arquivo mexe no Chats.js, no utilities.js nem no /v3/chat:
// só age com .open-ticket-detail na página e dentro de .tk-chat #ticket-detail-chat.
//  - Carga (execute-ajax-on-load → replaceContent no #ticket-detail-chat; troca de ticket troca o detalhe inteiro): fim, preso.
//  - Mensagem nova no FIM da lista (Pusher, envio de texto/flow/arquivo/áudio): fim SEMPRE, mesmo lendo acima (decisão D-1 do dono).
//    Troca de status do balão (replaceWith: o mesmo id sai e entra no mesmo lote) não é mensagem nova.
//  - Crescimento depois do primeiro paint (imagem, fonte, rodapé, painel único reexibido, janela): ResizeObserver na lista e em cada
//    filho direto; volta ao fim só se estiver preso. Solta só quando o usuário rola para CIMA (o ajuste do overflow-anchor nativo
//    só aumenta o scrollTop); volta a prender ao chegar a ≤ FOLGA px do fim.

const SEL_CHAT = '.tk-chat #ticket-detail-chat';
const SEL_LISTA = '.messages-chat-whats';
const FOLGA = 8;

const ConversaFim = function () {

    let vigiaChat = null;   // childList do #ticket-detail-chat atual
    let lista = null, ro = null, mo = null, aoRolar = null;
    let preso = true, ultimoTop = 0;

    const distanciaDoFim = (L) => L.scrollHeight - L.scrollTop - L.clientHeight;

    const irAoFim = () => {
        if (!lista || !lista.isConnected) return;
        lista.scrollTop = lista.scrollHeight;
        ultimoTop = lista.scrollTop;
    };

    const soltarLista = () => {
        if (ro) ro.disconnect();
        if (mo) mo.disconnect();
        if (lista && aoRolar) lista.removeEventListener('scroll', aoRolar);
        ro = mo = aoRolar = lista = null;
    };

    const ligarLista = (L) => {
        soltarLista();
        lista = L;
        preso = true;
        irAoFim();
        if (window.ResizeObserver) {
            ro = new ResizeObserver(() => { if (preso) irAoFim(); });
            ro.observe(L);
            Array.from(L.children).forEach((c) => ro.observe(c));
        }
        mo = new MutationObserver((lotes) => {
            const saiu = new Set();
            lotes.forEach((r) => r.removedNodes.forEach((n) => { if (n.nodeType === 1 && n.id) saiu.add(n.id); }));
            let nova = false;
            lotes.forEach((r) => r.addedNodes.forEach((n) => {
                if (n.nodeType !== 1) return;
                if (ro) ro.observe(n);
                if (n.parentNode === L && !n.nextElementSibling && !(n.id && saiu.has(n.id))) nova = true;
            }));
            if (nova) preso = true;
            if (preso) irAoFim();
        });
        mo.observe(L, { childList: true });
        aoRolar = () => {
            const t = L.scrollTop;
            if (distanciaDoFim(L) <= FOLGA) preso = true;
            else if (t < ultimoTop - 1) preso = false;
            ultimoTop = t;
        };
        L.addEventListener('scroll', aoRolar, { passive: true });
    };

    const verChat = (chat) => {
        const L = chat.isConnected ? chat.querySelector(SEL_LISTA) : null;
        if (!L) { soltarLista(); return; }   // carregando, e-mail/RA (EmailThread) ou erro: nada a ancorar
        if (L !== lista) ligarLista(L);
    };

    const aoTrocarDetalhe = () => {
        if (vigiaChat) { vigiaChat.disconnect(); vigiaChat = null; }
        soltarLista();
        const chat = document.querySelector(SEL_CHAT);
        if (!chat) return;
        vigiaChat = new MutationObserver(() => verChat(chat));
        vigiaChat.observe(chat, { childList: true });
        verChat(chat);
    };

    return {
        init: function () {
            const detalhe = document.querySelector('.open-ticket-detail');
            if (!detalhe) return;   // só na tela de tickets nova (o /v3/chat não tem .open-ticket-detail)
            new MutationObserver(aoTrocarDetalhe).observe(detalhe, { childList: true });
            aoTrocarDetalhe();
        },
        // oportunidades-2027 (ui-conversa DD-19): a conversa da oportunidade tem a MESMA âncora no fim, ligada pelo Oportunidades27.js
        // na lista que ele acabou de injetar (raiz própria #op-conversa-chat, sem .open-ticket-detail). Aditivo: o caminho acima não muda.
        ancorar: (L) => { if (L && L.isConnected) ligarLista(L); else soltarLista(); },
        soltar: () => soltarLista(),
    };
}();

module.exports = ConversaFim;
